import DialogVisible from '@/app-core/mixins/dialog/dialogVisible'
import DialogData from '@/app-core/mixins/dialog/dialogData'
import API from '@/app-core/api/Api'
import ResetPasswordModel from '@/app-core/api/models/user/ResetPasswordModel'

export default {
  name      : 'ResetPasswordDialog',
  components: {},
  mixins    : [DialogVisible, DialogData],
  props     : {},
  dataModel : ResetPasswordModel,
  data() {
    return {}
  },
  computed: {},
  methods : {
    onLoginClick() {
      this.closeDialog()
      this.$bus.$emit('login:show-dialog')
    },

    onResetPasswordClick() {
      this.saveFromData()
    },

    saveFromData() {
      if (!this.validateForm() || this.isFormSaving) return
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      this.isFormSaving = true

      this.model.ResetPassword()
        .then(response => {
          this.handleFormSaveResponse(response)
        })
        .catch(error => {
          this.handleFormSaveResponse(error.response)
        })
        .finally(() => {
          this.isFormSaving = false
        })
    },

    handleFormSaveResponse(response) {
      const data = API.responseData(response) || {}
      const message = data?.Messages

      if (API.isResponseSuccess(response)) {
        if (message.Success) {
          this.formSaveSuccess(data)
        } else {
          this.formSaveError(message?.Error || message?.Warning || message?.Info, true)
        }
      } else {
        this.formSaveError(message?.Error || message?.Warning || message?.Info, true)
      }
    }
  }
}
